import { CensusFormProvider } from '../components/provider/CensusFormProvider';
import CensusEditTabs from './CensusEditTabs';

export default function CensusEditPage({ fromPark }: { fromPark?: boolean }) {
  return (
    <CensusFormProvider speciesFilter="census">
      <CensusEditTabs fromPark={fromPark} />
    </CensusFormProvider>
  );
}